import { Typography } from 'antd'
import styled from 'styled-components'
import dayjs from 'dayjs'

import { Note } from '@types'

import { FlexCol } from '../StyledComponents'

const CommentContainer = styled(FlexCol)`
  width: 100%;
  height: fit-content;
  padding: 0 0;
  margin-bottom: 1rem;
  .name {
    font-weight: 700;
  }
  .date {
    color: #a1a1a1;
    margin-bottom: 0;
  }
`
const { Text } = Typography

interface CommentElementProps {
  data: Note
}

const CommentElement = ({ data }: CommentElementProps) => (
  <CommentContainer>
    <span className="date">
      {data.updateAt
        ? dayjs(data.updateAt).format('L [-] LT [hs]')
        : dayjs(data.createAt).format('L [-] LT [hs]')}
    </span>
    <Text style={{ gap: '0.5rem' }}>
      <span className="name">
        {`${data.user?.userDetail?.name} ${data.user?.userDetail?.surname}`}:{' '}
      </span>
      {data.description}
    </Text>
  </CommentContainer>
)

export { CommentElement }
